import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const workflowLaunchImporterSelectors = importerSelectors(
  'workflowLaunch.importer',
);

export default workflowLaunchImporterSelectors;
